<template>
  <section id="reviews">
    <div class="inner">
      <h2 v-html="$t('review_title')" />

      <!-- Mobile -->
      <div class="hidden-md-up mobile">
        <div class="review-images">
          <ReviewImage
            v-for="n in 6"
            :index="n"
          />
        </div>

        <SwiperLayout
          :modules="modules"
          :pagination="false"
          :breakpoints="breakpoints"
          :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
          }"
          class="review-texts"
        >
          <SwiperSlide v-for="n in 4">
            <ReviewText :index="n" />
          </SwiperSlide>
        </SwiperLayout>
      </div>

      <!-- Desktop -->
      <div class="hidden-md-down desktop">
        <div class="review-images">
          <ReviewImage
            v-for="n in 6"
            :index="n"
          />
        </div>

        <div class="review-texts">
          <ReviewText
            v-for="n in 4"
            :index="n"
          />
        </div>
      </div>
    </div>

    <div class="create-container">
      <a
        :href="productIndex()"
        class="secondary-btn"
      >{{
        $t("Create glass")
      }}</a>
    </div>
  </section>
</template>
<script>
import {
  SwiperSlide, Autoplay, Pagination, Navigation,
} from 'swiper/vue'
import SwiperLayout from '../../packages/views/carousel/Layout'
import { language } from '../../../helpers'
import useRoutes from '../../useRoutes'
import ReviewImage from './ReviewImage.vue'
import ReviewText from './ReviewText.vue'

export default {
  components: {
    SwiperSlide,
    SwiperLayout,
    ReviewImage,
    ReviewText,
  },
  setup() {
    const lang = language()

    const { productIndex } = useRoutes()

    const allReviewLink = 'https://www.google.com/search?q=glassery&sxsrf=ALiCzsa3Yr_m64I9iwxzsmdgZp-3fCR7xw%3A1664871321061&ei=mes7Y5ymA_T_7_UPsY2rwAg&ved=0ahUKEwjc1sD9kMb6AhX0_7sIHbHGCogQ4dUDCA4&uact=5&oq=glassery&gs_lcp=Cgdnd3Mtd2l6EAMyBAgjECcyBQgAEIAEMgoIABCABBAKEMsBMggIABCABBDLATIKCAAQgAQQChDLATIKCAAQgAQQChDLATIECAAQHjIJCAAQHhDJAxAKMgYIABAeEAoyBggAEB4QCjoKCAAQRxDWBBCwAzoGCCMQJxATOgQIABBDOhAILhCxAxCDARDHARDRAxBDOgsIABCABBCxAxCDAToKCAAQsQMQgwEQQzoLCC4QgAQQsQMQ1AI6BQguEIAEOggILhCABBCxAzoOCC4QgAQQsQMQgwEQ1AI6CwguEIAEEMcBEK8BOgcILhDUAhBDOggILhCABBDLAToOCC4QgAQQxwEQrwEQywFKBAhBGABKBAhGGABQowlYtxZg2RpoA3ABeACAAaUDiAGiD5IBCTAuMy40LjAuMZgBAKABAcgBCMABAQ&sclient=gws-wiz#lrd=0x4db3a08673641941:0xc5b4f7f13cddf415,1,,,'

    return {
      modules: [Autoplay, Pagination, Navigation],
      lang,
      allReviewLink,
      productIndex,
    }
  },
  data() {
    return {
      reviewLink: [
        'https://g.co/kgs/FUkGaJ',
        'https://g.co/kgs/NcJ3gV',
        'https://g.co/kgs/TT1ag1',
        'https://g.co/kgs/7u5wa8',
        'https://g.co/kgs/SLg6dW',
      ],
      breakpoints: {
        1024: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
    }
  },
}
</script>
